import { createSlice } from "@reduxjs/toolkit";
import { fetchProfileUpdateItems } from "./ProfileupdateThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const profileUpdateSlice = createSlice({
  name: "profileupdate",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchProfileUpdateItems.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProfileUpdateItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchProfileUpdateItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default profileUpdateSlice.reducer;